import { render, staticRenderFns } from "./CommonSection.vue?vue&type=template&id=d0248118&scoped=true"
import script from "./CommonSection.vue?vue&type=script&lang=js"
export * from "./CommonSection.vue?vue&type=script&lang=js"
import style0 from "./CommonSection.vue?vue&type=style&index=0&id=d0248118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0248118",
  null
  
)

export default component.exports